<!-- prettier-ignore -->

<div class="step-interest-type-container" >
    <h1>{{'¿Qué te apetece?' | translate}}</h1>

    @if(items && items.length > 0){
        <div class="interest-types">
            @for(item of items; track $index) {
                <div class="categories-wrapper">
                    @if(tools.isDistributor){
                        <label class="checkbox-image">
                            <input type="checkbox" 
                                [value]="item.ids" 
                                (focusin)="focusin($event)" 
                                (change)="setDistributorSelectedOption(item)"
                            >
                            <div class="img-container">
                               @if(checkSubcategoriesActive(item.subcategories)){
                                <div class="badge">
                                    {{ checkSubcategoriesActive(item.subcategories) }}
                                </div>
                               }
                                <div class="img-wrapper" [ngClass]="{
                                    'selectedRegister': item.selected || checkSubcategoriesActive(item.subcategories),
                                    'setOpacity': !item.selected && !checkSubcategoriesActive(item.subcategories),
                                }">
                                    <cicerone-lazy-image 
                                        [url]="item.image" 
                                        [urlFallback]="item.imageFallback" 
                                        [altImage]="item.name?.[translate.currentLang]" 
                                    />
                                </div>
                            </div>
                            <span class="category-title">{{ item.name?.[translate.currentLang] }}</span>
                        </label>
                    }

                    @if(tools.isApp || isRegisterStandaloneApp){
                        <label class="checkbox-image">
                            <input type="checkbox" 
                                [value]="item.ids" 
                                (focusin)="focusin($event)" 
                                (change)="setAppSelectedOption(item)"
                            >
                            <div class="img-container">
                                @if(checkSubcategoriesActive(item.subcategories)){
                                    <div class="badge">
                                        {{ checkSubcategoriesActive(item.subcategories) }}
                                    </div>
                                }
                                <div class="img-wrapper" [ngClass]="{
                                    'selectedRegister': item.selected || checkSubcategoriesActive(item.subcategories),
                                    'setOpacity': !item.selected && !checkSubcategoriesActive(item.subcategories),
                                }">                                    
                                <cicerone-lazy-image 
                                        [url]="item.image" 
                                        [urlFallback]="item.imageFallback" 
                                        [altImage]="item.name?.[translate.currentLang]" 
                                    />
                                </div>
                            </div>
                            <span class="category-title">{{ item.name?.[translate.currentLang] }}</span>
                        </label>
                    }
                </div>
            }
        </div>
    }

</div>
